import styled from "styled-components";
import { device } from "../../../stylesheet/breakpoints";

export const RatingBox = styled.ul`
  list-style: none;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;

  @media ${device.desktop} {
    margin-bottom: 10px;
  }
`;

export const RatingItem = styled.li`
  width: 22px;
  height: 23px;
  text-align: center;
  color: var(--text-color);
  background-color: transparent;
  cursor: pointer;

  &.active {
    color: var(--bg-button);
  }

  @media ${device.desktop} {
    width: 30px;
    height: 30px;
  }
`;

export const TextBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-inline: 20px;
  font-weight: 400;
  font-size: 13px; //11
  line-height: 1.45;
  color: var(--text-color);

  @media ${device.desktop} {
    padding-inline: 30px;
    font-size: 13px;
    line-height: 1.6;
  }
`;
